<template>
  <section id="feedbackdiv" class="content">

    <!--filter-->
    <div class="feedback-filter">
      <span :class="filterMarker == 2?'feedback-filter-active feedback-filter-active-current':'feedback-filter-active'" v-on:click="toGetFeedbackList(0, true)">All</span>
      <span class="feedback-filter-symbol">&nbsp;&nbsp;&nbsp;>&nbsp;&nbsp;&nbsp;</span>
      <span :class="filterMarker == 1?'feedback-filter-active feedback-filter-active-current':'feedback-filter-active'" v-on:click="toFilterFeedbackList(0, 1, true)">Read</span>
      <span class="feedback-filter-symbol">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</span>
      <span :class="filterMarker == 0?'feedback-filter-active feedback-filter-active-current':'feedback-filter-active'" v-on:click="toFilterFeedbackList(0, 0, true)">Unread</span>
    </div>
    <!--/ filter-->


  <div class="feedback-content">

    <div class="box-footer box-comments feedback-content-group" v-for="(item,index) in feedbackList">

      <!--confirm-change-status modal-dialog-->
      <div class="modal fade in" id="modal-confirm-change-status">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span></button>
              <h4 class="modal-title">To Confirm Change Status</h4>
            </div>
            <div class="modal-body">
              <form class="form-horizontal">
                <div class="firmware-version-update">
                  <p>Do you really want to change this feedback's status ?</p>
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default pull-left" data-dismiss="modal" aria-label="Cancel">Cancel</button>
              <button type="button" class="btn btn-info" v-on:click="toChangeFeedbackStatus()">Yes, I do.</button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--/ confirm-change-status modal-dialog-->

      <img class="img-md feedback-content-user-img" v-on:click="toConfirmChangeStatus(index, item.fid, item.state)" src="../../../static/img/img_feedback_read.svg" v-if="item.state">
      <img class="img-md feedback-content-user-img" v-on:click="toConfirmChangeStatus(index, item.fid, item.state)" src="../../../static/img/img_feedback_unread.svg" v-else>
      <div class="comment-text feedback-content-user-comment">
        <span class="username">
          {{item.uid}}
          <span class="text-muted pull-right">{{item.time / 1000000 | formatDate}}</span>
        </span>
        {{item.contents}}
        <div class="feedback-content-user-information">
          <div class="feedback-content-user-email"><i class="fa fa-envelope-o feedback-content-user-email-icon"></i>{{item.email}}</div>
          <div class="feedback-content-user-email"><i class="fa fa-desktop feedback-content-user-email-icon"></i>{{item.deviceid}}</div>
        </div>
      </div>

    </div>

    <div v-show="isShowNoMoreData" class="no-more-data">
      <p class="no-more-data-content">There's no more data.</p>
    </div>

  </div>
  </section>
</template>
<script>
  import api from '../../api'
  import utils from '../../utils'
  import global from '../Global.vue'

  export default {
    name: 'Feedback',
    data () {
      return {
        feedbackList: [],
        currentPage: 0,
        currentDeviceListHeight: 0,
        filterMarker: 2,
        isClear: true,
        isShowNoMoreData: false,
        feedbackListIndex: '',
        feedbackListFid: '',
        feedbackListState: ''
      }
    },
    created () {
    },
    mounted () {
      this.toGetFeedbackList(0, true)
      window.addEventListener('scroll', this.winScroll, false)
    },
    beforeDestroy () {
    },
    methods: {
      getNextPage () {
        this.currentPage = this.currentPage + 1
        if (this.filterMarker === 2) {
          this.toGetFeedbackList(this.currentPage, false)
        } else {
          this.toFilterFeedbackList(this.currentPage, this.filterMarker, false)
        }
      },
      toGetFeedbackList (page, isClear) {
        var params = new URLSearchParams()
        var jsons = {
          appid: this.$route.query.appid,
          page: page
        }
        params.append('json', utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET))
        if (window.localStorage) {
          params.append('token', this.$router.app.$store.state.user.token)
        }
        this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
        api.request('post', '/feedback?_type=json', params)
          .then(response => {
            this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
            var data = response.data
            /* Checking if error object was returned from the server */
            if (data.Status !== 1) {
            } else {
              if (data.Result) {
                if (isClear) {
                  this.isShowNoMoreData = false
                  this.currentDeviceListHeight = 0
                  this.currentPage = 0
                  this.feedbackList = []
                  this.feedbackList = JSON.parse(utils.getDecodeRC4Hex(data.Result, global.APP_SECRET))
                  if (this.feedbackList.length === 0) {
                    this.isShowNoMoreData = true
                  }
                } else {
                  var tempList = JSON.parse(utils.getDecodeRC4Hex(data.Result, global.APP_SECRET))
                  this.feedbackList = this.feedbackList.concat(tempList)
                  if (data.Status === 1) {
                    this.isShowNoMoreData = true
                  }
                }
                this.filterMarker = 2
              }
            }
          })
      },
      toFilterFeedbackList (page, state, isClear) {
        if (state === 1) {
          this.filterMarker = 1
        } else {
          this.filterMarker = 0
        }
        var params = new URLSearchParams()
        var jsons = {
          appid: this.$route.query.appid,
          page: page,
          state: state
        }
        params.append('json', utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET))
        if (window.localStorage) {
          params.append('token', this.$router.app.$store.state.user.token)
        }
        this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
        api.request('post', '/feedback?_type=json', params)
          .then(response => {
            this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
            var data = response.data
            /* Checking if error object was returned from the server */
            if (data.Status !== 1) {
            } else {
              if (isClear) {
                this.isShowNoMoreData = false
                this.currentDeviceListHeight = 0
                this.currentPage = 0
                this.feedbackList = []
                this.feedbackList = JSON.parse(utils.getDecodeRC4Hex(data.Result, global.APP_SECRET))
                if (this.feedbackList.length === 0) {
                  this.isShowNoMoreData = true
                }
              } else {
                var tempList = JSON.parse(utils.getDecodeRC4Hex(data.Result, global.APP_SECRET))
                this.feedbackList = this.feedbackList.concat(tempList)
                if (data.Status === 1) {
                  this.isShowNoMoreData = true
                }
              }
            }
          })
      },
      toConfirmChangeStatus (i, fid, state) {
        this.feedbackListIndex = i
        this.feedbackListFid = fid
        this.feedbackListState = state
        window.jQuery('#modal-confirm-change-status').modal('show')
      },
      toChangeFeedbackStatus () {
        var i = this.feedbackListIndex
        var fid = this.feedbackListFid
        var state = this.feedbackListState
        if (state === 1) {
          state = 0
        } else {
          state = 1
        }
        var params = new URLSearchParams()
        var jsons = {
          appid: this.$route.query.appid,
          fid: fid,
          state: state
        }
        params.append('json', utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET))
        if (window.localStorage) {
          params.append('token', this.$router.app.$store.state.user.token)
          this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
          api.request('post', '/updatafeedback?_type=json', params)
            .then(response => {
              this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
              var data = response.data
              /* Checking if error object was returned from the server */
              if (data.Status !== 1) {
              } else {
                this.feedbackList[i].state = state
                window.jQuery('#modal-confirm-change-status').modal('hide')
              }
            })
        }
      },
      winScroll (e) {
        if (this.currentDeviceListHeight < window.jQuery('#feedbackdiv').height()) {
          if (window.jQuery(window).scrollTop() + window.jQuery(window).height() >= window.jQuery('#feedbackdiv').height()) {
            this.currentDeviceListHeight = window.jQuery(window).scrollTop() + window.jQuery(window).height()
            this.getNextPage()
          }
        }
      }

    },
    filters: {
      formatDate (time) {
        var date = new Date(time)
        return utils.formatDate(date, 'yyyy-MM-dd')
      }
    }
  }

</script>


<style>

</style>



// WEBPACK FOOTER //
// Feedback.vue?09fb136a